import React from 'react';
const tags = ['U10-U12', 'U13-U15', 'U17-U19', 'Preparazione Fisica', 'Tattica', 'Scouting'];
export function SolutionSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-211">
      <div className="max-w-4xl mx-auto text-center" data-id="element-212">
        <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white font-bold text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-213">
          🏆 Il Sistema più Completo per Allenatori di Basket in Italia
        </div>

        <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] mb-4 tracking-tight" data-id="element-214">
          BASKET <span className="text-[#FF6B00]" data-id="element-215">PRONTO™</span>
        </h2>

        <p className="text-[#0A0A0A] text-xl sm:text-2xl font-black mb-6" data-id="element-216">
          6 Volumi + 6 Bonus
        </p>

        <p className="text-[#5A5A66] text-base sm:text-lg max-w-2xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-217">
          Oltre 300 pagine. 150 allenamenti completi. 101 esercizi
          professionali. Tattica. Tecnica. Preparazione fisica. Gestione della
          squadra. <strong className="text-[#0A0A0A]" data-id="element-218">Tutto già pronto.</strong>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-[#0A0A0A] text-sm sm:text-base font-black mb-10" data-id="element-219">
          <span className="flex items-center gap-2" data-id="element-220">📄 Oltre 300 pagine</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-221">|</span>
          <span className="flex items-center gap-2" data-id="element-222">🏀 150 allenamenti</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-223">|</span>
          <span className="flex items-center gap-2" data-id="element-224">⚡ 101 esercizi</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-225">|</span>
          <span className="flex items-center gap-2" data-id="element-226">🎯 Tutte le categorie</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-227">
          {tags.map(tag => <span key={tag} className="bg-[#FAFAFA] border border-[#E5E5EA] text-[#0A0A0A] text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-228">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}